

















import { Component, Vue } from 'nuxt-property-decorator';

@Component
export default class CardArticleSkeleton extends Vue {}
